module.exports = __webpack_public_path__ + "img/terratalk-logo-fullcolor.90064fc8.svg";